import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import {
  createFileRoute,
  Outlet,
  redirect,
  useNavigate,
  useRouterState,
} from '@tanstack/react-router';
import { session, useSession } from '@/lib/auth/session';

export const Route = createFileRoute('/_authed')({
  beforeLoad: ({ location }) => {
    if (!session.get()) throw redirect({ to: '/login', search: { returnTo: location.href } });
  },
  component: Authed,
});

/** Leaves for the sign-in page the moment the session ends, here or in another tab. */
function Authed() {
  const current = useSession();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const href = useRouterState({ select: (s) => s.location.href });

  useEffect(() => {
    if (current) return;
    queryClient.clear();
    void navigate({ to: '/login', search: { returnTo: href }, replace: true });
  }, [current, href, navigate, queryClient]);

  return current ? <Outlet /> : null;
}
